module.exports = __webpack_public_path__ + "static/media/check.57169095.svg";